/**
 * 監視オブジェクト
 * callbackを設定し、必要に応じてイベント呼び出しを行う。
 * 登録方法======
 * const obj = this;
 * this.$observer.observe("refresh", obj.load.bind(obj));
 * 指定コンポネントのthis.load()を'refresh'という名前で登録する
 * 呼び出し======
 * this.$observer.observe("refresh", id);
 * refreshコールバックにidという引数を与えて呼び出す。
 */
export default {
    callbacks: {},
    observe(action, callback) {
        this.callbacks[action] = callback;
    },
    dispatch(action, ...args) {
        if (this.callbacks[action]) {
            this.callbacks[action](...args);
        }
    },
}